"use client";
import type { ReactNode } from "react";
import SortableList from "./SortableList";

export type ReorderItemType<T> = T & { id: string };

export default function ReorderGroup<T>({
  items,
  renderItem,
  setItems,
  selectedId,
  setSelectedId,
  handlePosition,
}: {
  items: ReorderItemType<T>[];
  renderItem: (item: ReorderItemType<T>, index: number) => ReactNode;
  setItems: (items: ReorderItemType<T>[]) => void;
  selectedId: string | null;
  setSelectedId: (id: string | null) => void;
  handlePosition?: "top" | "right";
}) {
  return (
    <SortableList
      items={items}
      onReorder={setItems}
      onItemClick={(item) => setSelectedId(item.id)}
      itemClassName={(item) =>
        `my-1 rounded-md pt-2 transition-shadow ${item.id === selectedId ? "bg-slateCustom/5" : "bg-white"}`
      }
      renderItem={(item, index, handle) => (
        <div
          className={
            handlePosition === "top"
              ? "flex flex-col-reverse"
              : "flex items-start justify-between"
          }
        >
          <div className="min-w-0 flex-auto">{renderItem(item, index)}</div>
          <div className={handlePosition === "top" ? "self-center" : ""}>
            {handle}
          </div>
        </div>
      )}
    />
  );
}
